<template>
  <v-ons-page class="map-splitter">
    <div class="content" v-if="isAreaDataLoaded">
      <v-ons-splitter>
        <v-ons-splitter-side
          width="550px"
          collapse=""
          side="left"
          class="splitter"
          :open="isShowPanel"
        >
          <destination-panel />
        </v-ons-splitter-side>

        <v-ons-splitter-content>
          <map-index />
        </v-ons-splitter-content>

        <!-- <v-ons-button
          class="back-to-top"
          modifier="light back"
          @click="backToTop"
        >
          TOPに戻る
        </v-ons-button> -->

      </v-ons-splitter>

      <visualization-panel />

      <scale-ruler />
    </div>
  </v-ons-page>
</template>

<script>
import destinationPanel from './destination/panel.vue';
import mapIndex from './index.vue';
import visualizationPanel from './visualization/panel.vue';
import scaleRuler from './scale_ruler.vue';

export default {
  components: {
    destinationPanel,
    mapIndex,
    visualizationPanel,
    scaleRuler,
  },
  data() {
    return {
      isAreaDataLoaded: false,
    };
  },
  computed: {
    isShowPanel: ({ $store }) => $store.state.destinationDetail.isShow || $store.state.destinationList.isShow,
  },
  async created() {
    await this.initializeLoading();
    
    this.$store.commit('map/setVisualizationLayerType', 'default');
    this.$store.commit('map/toggleVisualizationPanel', false);
    this.$store.dispatch('searchResult/allClearDestinations');
    this.$store.commit('map/resetVisualizationPinType');
    
    this.isAreaDataLoaded = true;
  },
  methods: {
    // backToTop() {
    //   this.$store.commit('appNavigator/pop');
    // },
    async initializeLoading() {
      try {
        await this.getPlaces();
        await this.getPlaceBuildings();
      } catch (error) {
        this.showErrorAlert('ログインに失敗しました', error);
      }
    },
    getPlaces() {
      return this.$store.dispatch('area/getPlaces');
    },
    getPlaceBuildings() {
      return this.$store.dispatch('area/getPlaceBuildings', 1);
    },
  },
};
</script>

<style scoped lang="scss">
.map-splitter /deep/ {
  ons-splitter-mask {
    display: none !important;
  }
}
.content {
  overflow: hidden;
}
.back-to-top {
  z-index: 4;
  margin: 40px 0 0 40px;
}
</style>



// WEBPACK FOOTER //
// splitter.vue?76141269